/**
 * @file Event Video
 */

import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

/**
 * Event Video component
 */
const vEventVideo = () => {
	const video = document.querySelector( '.v-event-video' );

	if ( ! video ) {
		return;
	}

	gsap.registerPlugin( ScrollTrigger );

	const background  = video.querySelector( '.v-event-video__inner' );
	const tweenVars   = {
		opacity:  1,
		duration: 1,
		ease:     'power1.inOut',
	};
	const triggerVars = {
		start:         'top+=10% bottom',
		trigger:       video,
		toggleActions: 'play none none reset',
	};

	gsap.fromTo( background, { opacity: 0 }, {
		scrollTrigger: triggerVars,
		...tweenVars,
	} );
};

export default vEventVideo;
